import { BlobProvider } from "@react-pdf/renderer";

const PrintComponent = ({ child, onPrintOpen }) => {
  let openOnce = false;
  return (
    <div>
      <BlobProvider document={child}>
        {({ url }) => {
          if (!openOnce && url) {
            window.open(url);
            openOnce = true;
            if (onPrintOpen) {
              onPrintOpen();
            }
          }
        }}
      </BlobProvider>
    </div>
  );
};

export default PrintComponent;
